import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles(() => ({
  root: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'stretch',
    position: 'relative',
  },
  content: {
    width: '100%',
  },
  mainContent: {
    minHeight: 'calc(100vh - 136px)',
    position: 'relative',
  },
  landing: {
    width: '100%',
    backgroundColor: '#edf4ff',
    position: 'relative',
  },
  retangulo: {
    width: '100%',
    height: '836px',
    backgroundColor: '#fff',
    display: 'flex',
    justifyContent: 'space-between',
  },
  mensagem: {
    paddingTop: '237px',
    paddingLeft: '120px',
  },
  saudacao: {
    width: '541px',
    height: '112px',
    fontSize: '49px',
    fontWeight: '500',
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: '1.14',
    letterSpacing: 'normal',
    color: '#0430ad',
  },
  info: {
    marginTop: '12px',
    width: '556px',
    height: '150px',
    fontSize: '20px',
    fontWeight: 'normal',
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: '1.5',
    letterSpacing: 'normal',
    color: '#5e6784',
  },
  paper: {
    position: 'relative',
    marginTop: '180px',
    marginRight: '154px',
    width: '458px',
    height: '362px',
    boxShadow: '0 24px 40px -16px rgba(6, 31, 128, 0.2)',
    backgroundColor: '#ffffff',
  },
  paperContent: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center'
  },
  logoSebrae: {
    width: '75px',
    height: '40px',
  },
  paperTitle: {
    fontWeight: 'bold',
    textTransform: 'uppercase',
    color: '#5e6784',
  },
  divisor: {
    width: '190px',
    height: '2px',
    backgroundColor: '#dfdfe6',
  },
  footer: {
    width: '458px',
    height: '62px',
    backgroundColor: '#edf4ff',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginTop: '22px',
  },
  ouSection: {
    display: 'flex',
    alignItems: 'center',
    marginTop: '28px',
    marginBottom: '34px',
  },
  ou: {
    fontSize: '20px',
    fontWeight: '600',
    color: '#5e6784',
  },
  link: {
    fontSize: '16px',
    fontWeight: '600',
    color: '#044ada',
    textTransform: 'uppercase',
    cursor: 'pointer',
  },
  quadradoTopoDireita: {
    position: 'absolute',
    right: 0,
    top: -62,
    width: 62,
    height: 62,
    backgroundColor: '#408bfc',
  },
  quadradoTopoEsquerda: {
    position: 'absolute',
    left: 0,
    top: -62,
    width: 62,
    height: 62,
    backgroundColor: '#408bfc',
  },
  quadradoEsquerdo: {
    position: 'absolute',
    left: -62,
    top: 0,
    width: 62,
    height: 62,
    backgroundColor: '#93bdfc',
  },
  quadradoDireita: {
    position: 'absolute',
    right: -62,
    bottom: 0,
    width: 62,
    height: 62,
    backgroundColor: '#408bfc',
  },
  quadradoBaixo: {
    position: 'absolute',
    right: 0,
    bottom: -62,
    width: 62,
    height: 62,
    backgroundColor: '#97c1ff',
  },
}));

export default useStyles;
